/**
 * Encodes only the characters that break query-string parsing (`% + & = # ?`) in
 * a taxonomy `path` value, leaving `/` and `-` readable. `encodeURIComponent`
 * would additionally encode the path separators and mangle the path.
 *
 * `%` is escaped to `%25` so any existing percent-escape in the canonical path
 * (e.g. `%27` apostrophes emitted by `build()`) survives the query-string
 * round-trip: the value is decoded once by the query parser on the API side, so
 * `%27` -> `%2527` -> `%27` rather than collapsing to a literal `'`, which would
 * fail the `%27`-keyed Contentstack lookup.
 */
export const encodePathQueryParam = (path: string): string =>
  path.replace(/[%+&=#?]/g, (char) => encodeURIComponent(char));
